import { apiQuery } from "utils/queries";
import { api } from "./restUtil";

// The level ladder is fixed server-side: the column is an enum over these names,
// and `value` orders them. Keep in step with Level.LEVELS in the server ORM.
export const LEVEL_NAMES = [
  "Complete Beginner",
  "Beginner",
  "Intermediate",
  "Advanced Intermediate",
  "Advanced",
  "Nearly Native",
] as const;

export type LevelName = (typeof LEVEL_NAMES)[number];

export type Level = {
  id: string;
  name: LevelName;
  score_range: [number, number];
  value: number;
};

type LevelListResponse = {
  list: Level[];
};

export const levelsQuery = apiQuery({
  key: "/levels",
  queryFn: async () => {
    const resp = await api.get<LevelListResponse>("/levels");
    return sortByLadderPosition(resp.list);
  },
});

export const adminLevelsQuery = apiQuery<LevelListResponse, void, void, Level[]>({
  key: "/admin/levels",
  select: resp => sortByLadderPosition(resp.list),
});

// Still read directly by the workshop dialogs, which resolve a level mid-submit.
export async function fetchAdminLevels() {
  const resp = await api.get<LevelListResponse>("/admin/levels");
  return sortByLadderPosition(resp.list);
}

// Both endpoints return rows in table order, which is not ladder order.
function sortByLadderPosition(levels: Level[]) {
  return [...levels].sort((a, b) => a.value - b.value);
}
